import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { getWidgetChampionshipData } from '../services/api';
import '../styles/fonts.css';
import '../styles/championship_detail.css';
import '../styles/widget.css';
import useWidgetResize from '../hooks/useWidgetResize';

const errorText = err => err?.message?.match(/details:\s*(.*)$/)?.[1] || err?.message || 'Não foi possível carregar os dados.';
const dateText = value => value ? new Date(value).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' }).toUpperCase() : '—';

export default function WidgetSchedule() {
  useWidgetResize();
  const { champId } = useParams();
  const [params] = useSearchParams();
  const token = params.get('token');
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) return setError('Token ausente.');
    getWidgetChampionshipData(token, champId).then(setData).catch(err => setError(errorText(err)));
  }, [token, champId]);

  if (error) return <div className="widget-page"><p className="widget-error">{error}</p></div>;
  if (!data) return <div className="widget-page"><p className="widget-muted">Carregando...</p></div>;
  const sessions = data.schedule || [];

  return <div className="widget-page"><div className="box-header"><h3>{data.championship?.name} — Calendário</h3><span className="box-header-count">{sessions.length} corridas</span></div>
    {sessions.length === 0 ? <p className="empty-state">Sem etapas.</p> : <div className="schedule-list">{sessions.map((session, i) => {
      const completed = session.start_time && new Date(session.start_time) < new Date();
      return <div key={session.league_session_id || session.subsession_id || i} className={`schedule-row ${completed ? 'schedule-done' : 'schedule-upcoming'}`}>
        <span className="schedule-num">{i + 1}</span><div className="schedule-info"><span className="schedule-track">{session.track_name || `Etapa ${i + 1}`}</span><span className="schedule-date">{dateText(session.start_time)}</span></div>
        <div className="schedule-action">{completed && session.subsession_id ? <a className="btn-results" href={`${window.location.pathname.replace('/schedule', '/results')}?token=${token}&race=${session.subsession_id}`}>Resultados</a> : <span className="badge-next">Em breve</span>}</div>
      </div>;
    })}</div>}
    <div className="widget-powered">Powered by <a href="https://celeritas.live">Celeritas</a></div>
  </div>;
}
